export function ExtractMimeType(base64String) {
    var firstPart = base64String.split(';')[0]
    var firstPartTokens = firstPart.split(':')
    if (firstPartTokens.length > 1) {
        return firstPartTokens[1]
    }
    return ''
}
